"use strict";
export const MAIN_WEBSOCKET = "main";
export const MESSAGE_SERVICE = "messageservice";
export const VIEW_WEBSOCKET = "view";
export const PAGE_WEBSOCKET = "page";
export const UPDATE_WEBSOCKET = "update";
export const LOGIN_SUCCESS = "loginSuccess";
export const OPEN_LOGIN_MODAL = "openLoginModal";
export const LOGOUT = "logout";
export const HOMEPAGE_JUMP = "homepageJump";
export const GROUP_ID = "groupId";
export const PROFILE_PROCESS_LAUNCH = "clientEvent.subBrowser.launch.progress";
export const PROFILE_BROWSER_CLOSED = "clientEvent.subBrowser.terminate";
export const DOWNLOAD_CLIENT_PROGRESS = "clientEvent.update.download.progress";
export const DOWNLOAD_CLIENT_SUCCESS = "clientEvent.update.download.complete";
export const DOWNLOAD_CLIENT_FAIL = "clientEvent.update.download.failed";
export const USED_ACCOUNTS = "used_accounts";
export const USED_SUB_ACCOUNTS = "used_sub_accounts";
export const LAST_ACCOUNT = "last_account";
export const LAST_SUB_ACCOUNT = "last_sub_account";
export const TOKEN_KEY = "token";
export const SESSION_KEY = "session";
export const RESTART = "RESTART";
export const LANGUAGE = "language";
export const CLIENT = "client";
export const SUCCESS = "success";
export const SESSION_URL = process.env.YM_TEST === "true" ? "https://gateway.kuajingvs.com/kjvs/pro-dev" : "https://gateway.kuajingvs.com/pro";
export const WEB_HTML = process.env.YM_TEST === "true" ? "https://app.kuajingvs.com" : "https://app.kuajingvs.com";
